interface StatsBarProps {
  countriesCount: number;
  placesCount: number;
}

export function StatsBar({ countriesCount, placesCount }: StatsBarProps) {
  return (
    <div
      role="status"
      aria-label={`Journey statistics: ${countriesCount} ${countriesCount === 1 ? 'country' : 'countries'}, ${placesCount} ${placesCount === 1 ? 'place' : 'places'}`}
      className="fixed bottom-0 left-0 right-0 z-[100] bg-bg-surface border-t border-bg-elevated"
    >
      <div className="h-14 lg:h-16 flex items-center justify-center gap-2">
        <span className="text-sm text-text-secondary">
          <span className="text-text-primary font-medium">{countriesCount}</span>
          {' '}
          {countriesCount === 1 ? 'country' : 'countries'}
        </span>
        <span className="text-text-muted">•</span>
        <span className="text-sm text-text-secondary">
          <span className="text-text-primary font-medium">{placesCount}</span>
          {' '}
          {placesCount === 1 ? 'place' : 'places'}
        </span>
      </div>
    </div>
  );
}
